import type {
  APIListingApplicantFeedbackEntry,
  APIListingOffer,
} from "models/types/api-listing";

// Offer statuses that represent an active contract rather than an open offer.
// On the Offers & Contracts page these render under "Active contracts" and are
// excluded from the "Offers" count. See CRM-13933.
export const ACTIVE_CONTRACT_STATUSES = ["accepted", "unconditional"];

export function isActiveContract(offer: APIListingOffer): boolean {
  return ACTIVE_CONTRACT_STATUSES.includes(offer.status.id);
}

// Offer-status buyer feedback that carries a price indication. Counted as an
// offer on both the Overview and Offers & Contracts surfaces. Kept in one place
// so the two surfaces can't diverge on the predicate. See CRM-13933.
export function offerFeedbackWithPrice(
  entries: APIListingApplicantFeedbackEntry[] = [],
): APIListingApplicantFeedbackEntry[] {
  return entries.filter(
    (entry) => entry.type.id === "offer" && !!entry.price_indication,
  );
}

// The set of records shown under the detail-page "Offers" badge: published
// offers that are NOT active contracts, plus offer-status feedback with a
// price. Excludes active contracts (they render under "Active contracts").
export function getOpenOffers(
  offers: APIListingOffer[] = [],
): APIListingOffer[] {
  return offers.filter((offer) => !isActiveContract(offer));
}

// The "Offers" count, shared by the Offers & Contracts "Offers" badge and the
// Overview "Total offers" stat so the two stay equal by construction.
export function countOffers(
  offers: APIListingOffer[] = [],
  feedbackEntries: APIListingApplicantFeedbackEntry[] = [],
): number {
  return getOpenOffers(offers).length + offerFeedbackWithPrice(feedbackEntries).length;
}
